exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".register-page{\n  width: 500px;\n  height: 100%;\n  margin: auto;\n  margin-top: 40px;\n}\n/* display: flex;\n  align-content: center;\n  justify-items: center;\n  align-items: center; */\n.form-group{\n  text-align: left !important;\n}\n\n.register-page .register-button{\n  margin-top: 30px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/statics/css/register.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/statics/css/register.css
// module chunks = 0